/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

import React, { Suspense, useContext, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import ProtectedRoute from "../components/utils/ProtectedRoute";
import UserContext from "../context/User";
import { useDispatch, useSelector } from "react-redux";
import { setRef } from "../redux/ref/action";
// Import Components

// Accounts Components
const Login = React.lazy(() => import("../components/userlogin/Login"));
const Authentication = React.lazy(() =>
  import("../components/userlogin/Authentication")
);
const Register = React.lazy(() => import("../components/userlogin/Register"));
const ForgotUsername = React.lazy(() =>
  import("../components/userlogin/ForgotUsername")
);
const ForgotPassword = React.lazy(() =>
  import("../components/userlogin/ForgotPassword")
);
const CreatePassword = React.lazy(() =>
  import("../components/userlogin/CreatePassword")
);
const Unauthorize = React.lazy(() =>
  import("../components/userlogin/Unauthorize")
);

// Dashboard components
// const Dashboard = React.lazy(() => import("../components/dashboard/Dashboard"));
// const Home = React.lazy(() => import("../components/main/Home"));
const Manage = React.lazy(() => import("../pages/Manage/"));
// const Certification = React.lazy(() =>
//   import("../pages/Certifications/Certification")
// );
// const Apiview = React.lazy(() => import("../pages/Apiview"));
const ApiAlign = React.lazy(() => import("../pages/ApiAlign"));
// const ServiceApiView = React.lazy(() => import("../pages/ServiceApiView"));
const AzureDummyTest = React.lazy(() =>
  import("../azureConfig/AzureDummyTest")
);

const FullScreenLoader = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        width: "100vw",
      }}
    >
      <CircularProgress size={100} thickness={1} />
    </div>
  );
};

const NormalLoader = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress thickness={2} />
    </div>
  );
};

function RootRoutes({ fallback }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ref = useSelector((state) => state.ref.ref);
  const location = useLocation();
  const Userconsumer = useContext(UserContext);
  const { handleLogin } = Userconsumer;

  const searchParams = new URLSearchParams(location.search);

  const username = searchParams.get("username");
  const password = searchParams.get("password");

  const isHideAppbar = username && password ? true : false;

  // useEffect(() => {
  //   if (ref === '/bian_portal_v') {

  // } },[ref])

  if (fallback) {
    return <FullScreenLoader />;
  }

  return (
    <>
      <Suspense fallback={<FullScreenLoader />}>
        <Routes>
          {!username && !password && (
            <>
              <Route path="/" element={<Login />} />
              <Route path="/account/*" element={<Authentication />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot/username" element={<ForgotUsername />} />
              <Route path="/forgot/password" element={<ForgotPassword />} />
              <Route
                path="/forgot/password/create/"
                element={<CreatePassword />}
              />
              <Route path="/unauthorized" element={<Unauthorize />} />
            </>
          )}

          <Route
            path="/api-align/*"
            element={
              <ProtectedRoute>
                <ApiAlign />
              </ProtectedRoute>
            }
          />
          <Route
            path="/manage/*"
            element={
              <ProtectedRoute>
                <Manage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/azureConfig/*"
            element={
              <ProtectedRoute>
                <AzureDummyTest />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Suspense>
    </>
  );
}

export default RootRoutes;
